import React, { ReactNode } from 'react';
import { motion, HTMLMotionProps } from 'framer-motion';
import Navbar from './Navbar';
import Footer from './Footer';
import { useTheme } from '../../context/ThemeContext';

type MotionMainProps = HTMLMotionProps<'main'> & {
  className?: string;
};

const MotionMain = motion.main as React.FC<MotionMainProps>;

interface LayoutProps {
  children: ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { darkMode } = useTheme();

  return (
    <div 
      className={`min-h-screen flex flex-col relative ${darkMode ? 'dark text-white' : 'text-gray-900'}`}
      style={{
        backgroundImage: `url(${process.env.PUBLIC_URL}/background.png)`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed',
        backgroundColor: darkMode ? 'rgba(17, 24, 39, 0.9)' : 'rgba(249, 250, 251, 0.9)',
        backgroundBlendMode: 'overlay'
      }}
    >
      <Navbar />
      <div className="flex-grow">
        <MotionMain
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
          className="container mx-auto px-4 py-8 flex-1"
        >
          {children}
        </MotionMain>
      </div>
      <Footer />
    </div>
  );
};

export default Layout;
